var _defs, _sodipodiNamedview, _metadata;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: "62.071518mm",
    height: "6.579061mm",
    viewBox: "0 0 62.071518 6.579061",
    id: "svg1074",
    inkscapeVersion: "1.0.1 (3bc2e813f5, 2020-09-07, custom)",
    sodipodiDocname: "logo.bdaff02f.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1068"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    inkscapeZoom: 31.678384,
    inkscapeCx: 40.765502,
    inkscapeCy: 25.57702,
    "inkscapeDocument-units": "mm",
    "inkscapeCurrent-layer": "layer1",
    "inkscapeDocument-rotation": 0,
    showgrid: "false",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0,
    "inkscapeWindow-width": 1918,
    "inkscapeWindow-height": 1054,
    "inkscapeWindow-x": 0,
    "inkscapeWindow-y": 24,
    "inkscapeWindow-maximized": 1
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata1071"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text254",
    style: {
      fontVariant: "normal",
      fontWeight: 800,
      fontSize: "7.71702px",
      fontFamily: "roboto",
      InkscapeFontSpecification: "roboto-ExtraBold",
      writingMode: "lr-tb",
      display: "inline",
      fill: "#ede4f4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352777
    },
    x: -0.81767255,
    y: 5.8631268
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan252",
    y: 5.8631268,
    x: -0.81767255,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontFamily: "roboto",
      InkscapeFontSpecification: "'roboto Bold'",
      strokeWidth: 0.352777
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontFamily: "roboto",
      InkscapeFontSpecification: "'roboto Bold'",
      fill: "#008080"
    },
    id: "tspan840"
  }, "&lt;"), /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontFamily: "roboto",
      InkscapeFontSpecification: "'roboto Bold'",
      fill: "#004455"
    },
    id: "tspan1661"
  }, "Untari"), /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontFamily: "roboto",
      InkscapeFontSpecification: "'roboto Bold'",
      fill: "#008080"
    },
    id: "tspan842"
  }, ".com/&gt;")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5647853a49a9aaa7aa1276b43c733026.svg";
export { ForwardRef as ReactComponent };